module.exports = __webpack_public_path__ + "static/media/6.f3ed5901.webp";